export const TicketStatusIds = {
  CLOSED: 44,
  SCHEDULED: 3,
  FORWARDED: 4,
};

export const TicketStatusColors = {
  // 63: { bgColor: 'background.secondary', textColor: 'element.secondary' },
  // 169: { bgColor: 'alert.secondary', textColor: 'alert.primaryAlt' },
  // 44: { bgColor: 'positive.secondary', textColor: 'positive.primaryAlt' },
};

// Token paths (resolved via get(theme.colors, ...) in the Tag component) so the status
// tags adapt to dark instead of being a fixed light pink/green with dark text.
export const TicketGroupStatusColors = {
  2: { bgColor: 'brand.secondary', textColor: 'brand.primaryAlt' },
  3: { bgColor: 'positive.secondary', textColor: 'positive.primaryAlt' },
};
